export const emailRegex = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
export const integerRegex = /^\d+$/;
export const decimalRegex = /^\d+.?\d+$/;
export const gstRegex = /^[0-9]{2}[a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[0-9]{1}[a-zA-Z]{1}[a-zA-Z0-9]{1}$/;
export const panRegex = /^[a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}$/;
export const pincodeRegex = /^([1-9][0-9]{5})?$/;
export const cityRegex = /^[a-zA-Z& ]+/;
export const phoneNumberRegex = /^[6789]\d{9}$/;
export const nonSpecialCharacterRegex = /^[a-zA-Z0-9 @#&-/)(=._\n]+$/g;
export const numberRegex = /^\d*\.?\d*$/;
// Regex to match both standard Google Maps and Google Maps short links
export const GOOGLE_MAPS_URL_PATTERN =
  /^(https:\/\/(www\.google\.com\/maps(\/.*)?(\?[\w=&]+)?)|https:\/\/maps\.app\.goo\.gl\/[a-zA-Z0-9_-]+)$/i;
// /^https:\/\/maps\.app\.goo\.gl\/[A-Za-z0-9]+$/;
export const gmapRegex = /^https?:\/\/(www\.)?(google\.com\/maps|maps\.app\.goo\.gl)\/.+$/;
export const yearRegex = /20[0-9]{2}/;
export const urlRegex = new RegExp(
  '^' +
    // protocol identifier (optional)
    // short syntax // still required
    '(?:(?:(?:https?|ftp):)?\\/\\/)' +
    // user:pass BasicAuth (optional)
    '(?:\\S+(?::\\S*)?@)?' +
    '(?:' +
    // IP address exclusion
    // private & local networks
    '(?!(?:10|127)(?:\\.\\d{1,3}){3})' +
    '(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})' +
    '(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})' +
    // IP address dotted notation octets
    // excludes loopback network 0.0.0.0
    // excludes reserved space >= 224.0.0.0
    // excludes network & broadcast addresses
    // (first & last IP address of each class)
    '(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])' +
    '(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}' +
    '(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))' +
    '|' +
    // host & domain names, may end with dot
    // can be replaced by a shortest alternative
    // (?![-_])(?:[-\\w\\u00a1-\\uffff]{0,63}[^-_]\\.)+
    '(?:' +
    '(?:' +
    '[a-z0-9\\u00a1-\\uffff]' +
    '[a-z0-9\\u00a1-\\uffff_-]{0,62}' +
    ')?' +
    '[a-z0-9\\u00a1-\\uffff]\\.' +
    ')+' +
    // TLD identifier name, may end with dot
    '(?:[a-z\\u00a1-\\uffff]{2,}\\.?)' +
    ')' +
    // port number (optional)
    '(?::\\d{2,5})?' +
    // resource path (optional)
    '(?:[/?#]\\S*)?' +
    '$',
  'i'
);
